
import { Vue, Component, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { namespace } from 'vuex-class';
import { VuexAction } from '@/types/functions';
import { IPage } from '@/interfaces/search';
import StateServiceMixin from '@/mixins/state-service';
import { range } from '@/services/utils-service';
import Dropdown from '@/mixins/common/dropdown';
import plural from '@/filters/plural-form';

import * as $ from 'jquery';
require('jquery-mousewheel')($);
require('malihu-custom-scrollbar-plugin')($);

const searchStore = namespace('search');

interface IMixins extends StateServiceMixin, Dropdown {}

@Component({
  filters: {
    plural,
  },
})
export default class SearchAdvertsPagination extends Mixins<IMixins>(
  StateServiceMixin,
  Dropdown
) {
  @searchStore.State advertsListPage!: IPage;
  @searchStore.State total!: number;
  @searchStore.Action setPage!: VuexAction;

  mounted() {
    ($(this.$refs.pagesContainer) as any).mCustomScrollbar({
      axis: 'x',
      scrollInertia: 0,
      advanced: {
        updateOnContentResize: false,
        updateOnSelectorChange: true,
      },
    });
  }

  private get pages() {
    return range(1, this.advertsListPage.last + 1);
  }

  private get count() {
    return this.advertsListPage.current < this.advertsListPage.last - 1
      ? this.advertsListPage.limit
      : this.total % this.advertsListPage.limit || this.advertsListPage.limit;
  }

  private showNextPage() {
    const page = this.advertsListPage.current + 1;

    this.setCurrentPage(page);
  }

  private setCurrentPage(page: number) {
    this.setPage({
      page,
    });

    page === 1
      ? this.stateService.removeProperty('page')
      : this.stateService.setProperty('page', page.toString());

    (document.getElementById('list') as HTMLElement).scrollIntoView();

    this.closeDropdown();
  }

  private scrollToPage(page: string) {
    const pageNode = this.$refs[`page_${page}`];

    ($(this.$refs.pagesContainer) as any).mCustomScrollbar(
      'scrollTo',
      pageNode
    );
  }

  @Watch('pages')
  onPagesInit(pages: Array<number>) {
    if (pages.length > 1) {
      this.$nextTick(() => {
        this.scrollToPage(this.advertsListPage.current.toString());
      });
    }
  }
}
